import { Component, Input, Output, EventEmitter, AfterViewChecked, ViewChildren } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Rx';
import { FileRestrictions, SelectEvent, ClearEvent, RemoveEvent } from '@progress/kendo-angular-upload';
import { CgpConfirmationDialogService } from '../cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpSnackbarService } from '../cgp-snackbar/cgp-snackbar.service';

@Component({
    selector: 'cgp-tabbed-form-dialog',
    templateUrl: './cgp-tabbed-form-dialog.component.html',
    // styleUrls: ['./cgp-tabbed-form-dialog.component.scss'],
    host: { 'class': 'dialog-window' },
})
export class CgpTabbedFormDialogComponent {

    // implements AfterViewChecked
    // @ViewChildren('input') vc;
    // ngAfterViewChecked(): void {
    //     if (this.active) this.focusFirst();
    // }

    @Input() isNew: boolean = false;
    @Input() title: string;
    @Input() formGroup: FormGroup;
    @Input() formControls: any[] = [];
    @Input() tabs: any[] = [];
    @Input() set model(obj: any) {
        if (obj) this.formGroup.reset(obj);
        this.active = obj !== undefined;
    }

    @Output() cancel: EventEmitter<any> = new EventEmitter();
    @Output() save: EventEmitter<any> = new EventEmitter();
    @Output() refresh: EventEmitter<any> = new EventEmitter();

    active: boolean = false;
    isSearchHidden: boolean = false;
    actionFormDialog: any = undefined;
    panelBarControlSelectedItem: any = undefined;
    isActionFormDialogNew: boolean = false;


    constructor(
        private cgpConfirmationDialogService: CgpConfirmationDialogService,
        private cgpSnackbarService: CgpSnackbarService,
    ) { }


    private onSave(e): void {
        e.preventDefault();
        this.save.emit(this.formGroup.value);
        this.active = false;
        this.isSearchHidden = false;
    }

    private resetFilters() {
        try {
            for (let c of this.formControls) {
                if (c.service) {
                    c.service.resetFilter();
                }
            }
        } catch (e) { }
    }

    private onCancel(e): void {
        e.preventDefault();
        this.resetFilters();
        this.closeForm();
    }


    private closeForm(): void {
        this.isSearchHidden = false;
        this.active = false;
        this.cancel.emit();
    }


    private userLookup(gmin, service) {
        service.getUserByGmin(gmin)
            .then(obj => {
                this.model = obj;
                this.formGroup.reset(obj);
                this.isSearchHidden = obj !== undefined;
            });
    }

    private onSearch(e, control) {
        let node = e.target;
        if (e.type == 'click') node = node.previousElementSibling;

        if (node.value) {
            this.userLookup(node.value, control.service);
        }
    }

    private clearSearch(e, control) {
        this.formGroup.controls[control.name].reset();
        this.isSearchHidden = false;
    }


    private isDisabled(state: string): boolean {
        return state === 'always' ||
            state === 'create' && this.isNew ||
            state === 'update' && !this.isNew;
    }


    private onPanelBarItemEdit(control, isNew) {
        if (control) {
            this.isActionFormDialogNew = isNew;
            this.actionFormDialog = control.editTemplate.formDialog;
            this.actionFormDialog.control = control;

            let dataItem = isNew ? undefined : this.panelBarControlSelectedItem;
            this.actionFormDialog.edit(dataItem);

        }
    }


    private actionFormSaveHandler(editDataItem) {
        if (!this.isActionFormDialogNew) editDataItem.id = this.panelBarControlSelectedItem.id;
        this.actionFormDialog.save(editDataItem, this.formGroup, this.isActionFormDialogNew);
        this.isActionFormDialogNew = false;
    }


    private actionFormCancelHandler() {
        this.actionFormDialog = undefined;
        this.isActionFormDialogNew = false;
    }


    private panelBarControlstateChange(dataItems: any[]) {
        this.panelBarControlSelectedItem = dataItems.find(item => item.selected);
    }


    private onPanelBarItemDelete(control, dataItem) {
        var self = this;
        this.cgpConfirmationDialogService.showConfirmationDialog({
            title: 'Delete Confirmation',
            message: 'Are you sure that you want to delete this record?',
            alert: 'danger',
            onYesClick: () => {
                control.editTemplate.formDialog.delete(dataItem);
                this.cgpConfirmationDialogService.closeConfirmationDialog();
            },
            onNoClick: () => {
                this.cgpConfirmationDialogService.closeConfirmationDialog();
            }
        });
    }

    private onDialogAction(control: any) {
        control.callback()
            .then(response => {
                if (control.refresh) this.refresh.emit(true);
                if (control.close) this.closeForm();
            });
    }

    // focusFirst() {
    //     try {
    //         try {
    //             this.vc.first.nativeElement.focus();
    //         } catch (e) {
    //             this.vc.first.focus()
    //         }
    //     } catch (e) { }
    // }
}
